export const PostalCheck = (postal: string) => {
  const postalRegex = /^[1-9][0-9]{3}[\s]?[a-zA-Z]{2}$/;
  return postalRegex.test(postal);
}